$(document).on('turbolinks:load', function() {
  setTimeout(function() {
    if (Tos && Tos.getTimeOnPage() && Tos.getTimeOnPage().timeOnPage > 0) {
      $('#TimeOnSiteTracker').trigger('onload');      
    }
  }, 100);
});
